import { toolsActions, jobsActions } from '../../actions';
import {
    IServerChat,
    IServerChatHistory,
    IServerJobRequirementRecommendation,
} from '../../common';
import { store } from '../base-redux/store';
import { SocketMessage } from './socket.types';
import { SocketMessages } from './sockets.consts';

// eslint-disable-next-line no-unused-vars
export const handleMessage = (payload: SocketMessage) => {
    const { dispatch } = store;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, data } = payload;
    console.log('handleMessage', title, data);
    switch (title) {
        case SocketMessages.TOOL_CHAT_CREATE_SUCCESS:
            dispatch(
                toolsActions.handleCreateChatSuccessMessage(data as IServerChat)
            );
            break;
        case SocketMessages.TOOL_CHAT_REPLY:
            dispatch(
                toolsActions.handleChatReplyFromAI(data as IServerChatHistory)
            );
            break;
        case SocketMessages.TOOL_CHAT_CREATE_FAILED:
            console.log('TOOL_CHAT_CREATE_FAILED', data);
            break;
        case SocketMessages.SEND_CHAT_MESSAGE_SUCCESS:
            console.log('SEND_CHAT_MESSAGE_SUCCESS', data);
            break;
        case SocketMessages.SEND_CHAT_MESSAGE_FAILED:
            console.log('SEND_CHAT_MESSAGE_FAILED', data);
            break;
        case SocketMessages.REQUIREMENT_RECOMMENDATION_LIST: {
            const payload = data as {
                job_id: number;
                recommendations: Array<IServerJobRequirementRecommendation>;
                is_exhausted: boolean;
            };
            const activeJobId = store.getState().jobs.activeJob?.id;
            if (
                activeJobId == null ||
                Number(payload.job_id) !== Number(activeJobId)
            ) {
                break;
            }
            dispatch(
                jobsActions.handleJobRequirementsRecommendationsReady({
                    recommendations: payload.recommendations,
                    is_exhausted: payload.is_exhausted,
                })
            );
            break;
        }
        default:
            break;
    }
};
